'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleIcons = require('reactackle-icons');

var _reactackleTooltip = require('reactackle-tooltip');

var _reactackleCore = require('reactackle-core');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _reactackleCore.registerDefaultComponentTheme)('tag', _styles.componentTheme);

/**
 * Combined with tooltip
 */

var propTypes = {
  /**
   * Bounded tag has max width, long text may be cut
   */
  bounded: _propTypes2.default.bool,
  /**
   * Define icon component
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * Tag text
   */
  text: _propTypes2.default.string,
  /**
   * Tooltip text
   */
  tooltipText: _propTypes2.default.string,
  /**
   * Redefines background color
   */
  bgColor: _propTypes2.default.string,
  /**
   * Redefines text color
   */
  textColor: _propTypes2.default.string,
  /**
   * Redefines icon color
   */
  iconColor: _propTypes2.default.string,
  /**
   * Adds remove button
   */
  removable: _propTypes2.default.bool,
  /**
   * Remove Icon
   */
  iconRemove: _propTypes2.default.element,
  /**
   * Function to be called in remove button click
   */
  onRemove: _propTypes2.default.func,
  /**
   * @ignore
   */
  toggleTooltip: _propTypes2.default.func,
  /**
   * @ignore
   */
  showTooltip: _propTypes2.default.func,
  /**
   * @ignore
   */
  hideTooltip: _propTypes2.default.func
};

var defaultProps = {
  bounded: false,
  icon: null,
  text: '',
  tooltipText: '',
  bgColor: '',
  textColor: '',
  iconColor: '',
  removable: false,
  iconRemove: _react2.default.createElement(_reactackleIcons.IconCross, { size: 'custom', color: 'currentColor' }),
  onRemove: _reactackleCore.noop,
  toggleTooltip: _reactackleCore.noop,
  showTooltip: _reactackleCore.noop,
  hideTooltip: _reactackleCore.noop
};

var TagComponent = function TagComponent(_ref) {
  var bounded = _ref.bounded,
      removable = _ref.removable,
      icon = _ref.icon,
      iconRemove = _ref.iconRemove,
      text = _ref.text,
      tooltipText = _ref.tooltipText,
      bgColor = _ref.bgColor,
      textColor = _ref.textColor,
      iconColor = _ref.iconColor,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['bounded', 'removable', 'icon', 'iconRemove', 'text', 'tooltipText', 'bgColor', 'textColor', 'iconColor', 'children']);

  var tooltip = tooltipText && _react2.default.createElement(
    props.Tooltip,
    null,
    tooltipText
  );

  var textElement = text && _react2.default.createElement(
    _styles.TextStyled,
    { isBounded: bounded, title: text },
    text
  );

  var removeButton = removable && _react2.default.createElement(
    _styles.RemoveIconStyled,
    { onClick: props.onRemove },
    iconRemove
  );

  var iconElement = null;

  if (icon) {
    if (typeof icon === "function") {
      var Icon = icon;
      iconElement = _react2.default.createElement(
        _styles.IconStyled,
        { iconColor: iconColor },
        _react2.default.createElement(Icon, null)
      );
    } else {
      iconElement = _react2.default.createElement(
        _styles.IconStyled,
        { iconColor: iconColor },
        icon
      );
    }
  }

  var wrapperProps = {
    onClick: props.toggleTooltip,
    onFocus: props.showTooltip,
    onBlur: props.hideTooltip,
    onMouseEnter: props.showTooltip,
    onMouseLeave: props.hideTooltip
  };

  return _react2.default.createElement(
    _styles.TagStyled,
    _extends({}, wrapperProps, {
      bgColorCustom: bgColor,
      textColorCustom: textColor
    }),
    iconElement,
    _react2.default.createElement(
      _styles.ContentStyled,
      {
        hasIcon: !!icon,
        isBounded: bounded,
        isRemovable: removable
      },
      textElement,
      children
    ),
    removeButton,
    tooltip
  );
};

exports.TagComponent = TagComponent;
TagComponent.propTypes = propTypes;
TagComponent.defaultProps = defaultProps;
TagComponent.displayName = 'Tag';

exports.default = (0, _reactackleTooltip.withTooltip)(TagComponent, true);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tag/dist/Tag.js
// module id = 827
// module chunks = 0